import "./bootstrap.js";
import "../css/app.css";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import PrimeVue from "primevue/config";
//import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/themes/aura-light-noir/theme.css";
import ToastService from "primevue/toastservice";
import { InertiaProgress } from "@inertiajs/progress";
import ConfirmationService from "primevue/confirmationservice";
import FocusTrap from "primevue/focustrap";
import Tooltip from "primevue/tooltip";
import "primeicons/primeicons.css";
import assetsMixin from "./assets.js";
import il8n from "./il8n.js";
import Calendar from "primevue/calendar";

// Patch PrimeVue Calendar to automatically change hours when minutes roll over
if (Calendar && Calendar.methods) {
    const originalIncrementMinute = Calendar.methods.incrementMinute;
    if (originalIncrementMinute) {
        Calendar.methods.incrementMinute = function (event) {
            let prevMinute = this.currentMinute;
            originalIncrementMinute.call(this, event);
            if (this.currentMinute < prevMinute) {
                this.incrementHour(event);
            }
        };
    }

    const originalDecrementMinute = Calendar.methods.decrementMinute;
    if (originalDecrementMinute) {
        Calendar.methods.decrementMinute = function (event) {
            let prevMinute = this.currentMinute;
            originalDecrementMinute.call(this, event);
            if (this.currentMinute > prevMinute) {
                this.decrementHour(event);
            }
        };
    }
}


createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),

  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });
    app
      .use(plugin)
      .use(PrimeVue, {
          locale: {
              firstDayOfWeek: 1,
              dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
              dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
              monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
              today: "Heute",
              clear: "Löschen",
              dateFormat: "dd.mm.yy",
              weekHeader: "KW"
          }
      })
      .use(ToastService)
      .use(ConfirmationService)
      .use(il8n)
      .mixin(assetsMixin);
    
    app.config.globalProperties.route = window.route;

    app.directive("focustrap", FocusTrap);
    app.directive("tooltip", Tooltip);

    app.mount(el);

    return app;
  },
});

InertiaProgress.init({
  color: "#4B5563",
  delay: 250,
  includeCSS: true,
  showSpinner: true,
});
